import BusinessPersonBase from "features/contracting/models/steps/customerData/BusinessPersonBase";
import ContactPersonDTO from "features/contractualAccounts/dtos/ContactPersonDTO";
import { getPhoneInputPrefixtDefault, loadPhoneInputConfiguration } from "features/shared/forms/components/phoneInput/phoneInputConfig";

export const getBusinessPerson = (
  person: ContactPersonDTO
): BusinessPersonBase => {
  const email = person.contacts?.find((x) => x.contactType === "Email")?.value;
  const mobile = person.contacts?.find((x) => x.contactType === "Mobile")?.value;
  const beforeNameDegree = person.degrees?.find(x => x.isInFrontOfName)?.value; 
  const afterNameDegree = person.degrees?.find(x => !x.isInFrontOfName)?.value; 

  const { mobilePrefix, mobileNumber } = parseMobileNumber(mobile);

  return {
    firstName: person.firstname,
    surname: person.lastname,
    email: email,
    mobilePrefix: mobilePrefix,
    mobileNumber: mobileNumber,
    beforeNameDegree: beforeNameDegree,
    afterNameDegree: afterNameDegree
  };
};

export const parseMobileNumber = (
  input?: string
): { mobilePrefix: string | undefined; mobileNumber: string | undefined } => {
  if (!input || input.trim() === "") {
    return { mobilePrefix: undefined, mobileNumber: undefined };
  }

  const phoneConfigs = loadPhoneInputConfiguration();

  for (const config of phoneConfigs.sort(
    (a, b) => b.prefix.length - a.prefix.length
  )) {
    if (input.startsWith(config.prefix)) {
      return {
        mobilePrefix: config.prefix,
        mobileNumber: input.substring(config.prefix.length),
      };
    }
  }
  // default prefix
  return { mobilePrefix: getPhoneInputPrefixtDefault(), mobileNumber: input };
};